import { Injectable } from '@angular/core';
import { SharedService } from '../services/shared.service';

@Injectable({
  providedIn: 'root'
})
export class BordereauService {

  constructor(private sharedService: SharedService) { }


  // Save Indicative Quote
  download(data) {
    return this.sharedService.postDownload('bordereau/download', data);
  }

  // Export live report
  live() {
    return this.sharedService.postDownload('bordereau/live', '');
  }

  // Get Products List
  getProducts() {
    return this.sharedService.getAPI('products');
  }

  // Export lapse report
  lapse(data) {
    return this.sharedService.postDownload('bordereau/lapse', data);
  }

  // Export policy report
  policy(data) {
    return this.sharedService.postDownload('bordereau/policy', data);
  }
  // Export policy report
  policyBreakdown(data) {
    return this.sharedService.postDownload('breakdown/policy/export', data);
  }
  // Export policy report
  policyExcessProtect(data) {
    return this.sharedService.postDownload('excessprotect/policy/export', data);
  }

  // Export policy report
  policySDTK(data) {
    return this.sharedService.postDownload('sdtk/policy/export', data);
  }

  policyEquine(data) {
    return this.sharedService.postDownload('equine/policy/export', data);
  }
}

